var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9991",
    "data-name": "Group 9991",
    transform: "translate(-3417 -12393.84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5159",
    "data-name": "Rectangle 5159",
    width: 20,
    height: 20,
    transform: "translate(3417 12393.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_3178344_location_marker_pin_pointer_icon",
    "data-name": "3178344_location_marker_pin_pointer_icon",
    transform: "translate(3419.204 12394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18491",
    "data-name": "Path 18491",
    d: "M15.481,4A7.481,7.481,0,0,0,8,11.481C8,17.7,14.64,22.7,15.481,22.7s7.481-5,7.481-11.222A7.481,7.481,0,0,0,15.481,4Zm0,17.74c-1.075-.524-6.546-4.882-6.546-10.259a6.546,6.546,0,1,1,13.092,0C22.028,16.859,16.557,21.216,15.481,21.74Z",
    transform: "translate(-8 -4)",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18492",
    "data-name": "Path 18492",
    d: "M20.273,13a3.273,3.273,0,1,0,3.273,3.273A3.273,3.273,0,0,0,20.273,13Zm0,5.611a2.338,2.338,0,1,1,2.338-2.338A2.338,2.338,0,0,1,20.273,18.611Z",
    transform: "translate(-12.792 -8.792)",
    fill: "#939393"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1dcf4502726904b41622ba340dde965b.svg";
export { ForwardRef as ReactComponent };